export default "__VITE_ASSET__DdWIqSAE__"